import React from 'react';
import skinsStyles from './styles/WoodScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const WoodScreen: React.FC<
  Omit<BaseScreenSkinProps, 'skin' | 'skinStyles'>
> = props => <BaseScreenSkin {...props} skinStyles={skinsStyles} />;

export default WoodScreen;
